module.exports = __webpack_public_path__ + "static/media/me.73f04368.png";